import Vue from 'vue';
import App from './App.vue';
import './plugins/logging';
import './plugins/time-format';
import './plugins/vue-devtools';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router';
import {Logger} from '@vanti/vue-logger';
import {Notify} from './plugins/vue-notify';
import {isParentWindow} from '@/api/consts';

Vue.use(Notify, {store});

const log = Logger.get('main');
log.info(`Current application version: ${store.state.versions.VERSION} @ ${store.state.versions.COMMITHASH}`);

Vue.config.productionTip = false;

// this is to avoid reload during acquireTokenSilent() because of hidden iframe used for auth
// eslint-disable-next-line max-len
// see: https://github.com/AzureAD/azure-activedirectory-library-for-js/wiki/FAQs#q1-my-app-is-re-loading-every-time-adal-renews-a-token
if (isParentWindow) {
  log.debug('initialising');
  new Vue({
    vuetify,
    store,
    router,
    render: h => h(App)
  }).$mount('#app');
} else {
  log.debug('in iframe, skipping initialisation');
}
